(function () {
    const showAllAgain = () => {
        console.log('showAllAgain');
        const allFaqItems = document.querySelectorAll('.accordion-item');
        allFaqItems.forEach((item) => {
            item.classList.remove('hidden');
        });
    };

    const filterOutItemsBySubcategory = (subcategory) => {
        const allFaqItems = document.querySelectorAll('.accordion-item');

        allFaqItems.forEach((item) => {
            const { dataset } = item;
            const itemSubcategory = dataset.subcategory;
            // this is the show all button
            if (subcategory === itemSubcategory) {
                item.classList.remove('hidden');
            } else {
                item.classList.add('hidden');
            }
        });
    };

    const handleFAQsearchClick = (event) => {
        event.preventDefault();
        const { dataset } = event.target;
        const { subcategory } = dataset;
        console.log(subcategory);

        const allFAQSearchlinks = document.querySelectorAll(
            '.funnelback-search-facets-breadcrumb__button__faq-subcategory'
        );

        allFAQSearchlinks.forEach((item) => {
            if (item !== event.target) {
                item.classList.remove('selected');
            } else {
                item.classList.add('selected');
            }
        });

        if (subcategory === '') {
            showAllAgain();
        } else {
            filterOutItemsBySubcategory(subcategory);
        }
    };

    const initFAQsearchCards = () => {
        const allFAQSearchlinks = document.querySelectorAll(
            '.funnelback-search-facets-breadcrumb__button__faq-subcategory'
        );
        allFAQSearchlinks.forEach((item) => {
            item.addEventListener('click', handleFAQsearchClick);
        });
    };

    const init = () => {
        initFAQsearchCards();
    };

    init();
})();
